import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionComponents = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "c3e7c6b7-650d-456d-8997-a4d049587d58",
			"type": "page",
			"properties": {
				"title": [
					[
						"Компоненты"
					]
				]
			},
			"content": [
				"b85df0ca-d7fd-4dc5-9be1-f27f77e96c0f",
				"7b7fa5b9-3051-4589-a82a-834fa4491387",
				"47f31afc-00d8-4831-8d0c-686fbdcd4f7e",
				"ff0c0388-8a4a-42a2-9f0c-6d8339c9d40a",
				"a46b6938-1173-4ec7-92eb-0cdad95c10cb",
				"98561cc3-ef0a-4c09-b2c3-b4e3956fd6c5"
			],
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b85df0ca-d7fd-4dc5-9be1-f27f77e96c0f",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/components\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "932973be-4901-40be-a9f4-ce7e3642e0fd",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "c3e7c6b7-650d-456d-8997-a4d049587d58",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7b7fa5b9-3051-4589-a82a-834fa4491387",
			"type": "text",
			"properties": {
				"title": [
					[
						"Базовые элементы интерфейса, из которых создаются более сложные компоненты и экраны."
					]
				]
			},
			"parent_id": "c3e7c6b7-650d-456d-8997-a4d049587d58",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "47f31afc-00d8-4831-8d0c-686fbdcd4f7e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Сейчас дизайн–система Paradigm работает на компонентах VKUI. "
					]
				]
			},
			"parent_id": "c3e7c6b7-650d-456d-8997-a4d049587d58",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ff0c0388-8a4a-42a2-9f0c-6d8339c9d40a",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://vkcom.github.io/VKUI/#/About"
					]
				],
				"title": [
					[
						"VKUI styleguide"
					]
				],
				"caption": [
					[
						"VKUI  Styleguide"
					]
				]
			},
			"format": {
				"bookmark_icon": "https://vk.com/images/icons/favicons/fav_logo_2x.ico?6"
			},
			"parent_id": "c3e7c6b7-650d-456d-8997-a4d049587d58",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a46b6938-1173-4ec7-92eb-0cdad95c10cb",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Раздел скоро обновится"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "dec0e7f1-3419-49bf-b772-f12baaa21031",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "c3e7c6b7-650d-456d-8997-a4d049587d58",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "98561cc3-ef0a-4c09-b2c3-b4e3956fd6c5",
			"type": "text",
			"parent_id": "c3e7c6b7-650d-456d-8997-a4d049587d58",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": []
}} />
);

export default NotionComponents;
